export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات التسجيل"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التحقق"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عام"])}
}